import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from '../../services/api.service';
import { ApiAnalyticsService } from '../../services/api-analytics.service';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';
import { URL_IMG } from '../../constants/general';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.scss'],
  host:{
    'class':'col forms-confirmation-style d-flex justify-content-center first-identification-content'
  }
})
export class IdentificationComponent implements OnInit {

  form: UntypedFormGroup;
  subsFileOne: Subscription;
  subsFileTwo: Subscription;
  idTypes:any[]=[]; 
  idTypesRadio:any[]=[];
  idTypesSelect:any[]=[];
  idDefault:any=[]
  generalData:any = {};
  showFiles:boolean=false;
  showFileTwo:boolean=false;
  file_text:string='Seleccionar frente';
  invalidSizeOne:boolean=false;
  invalidSizetwo:boolean=false;
  invalidExtOne:boolean=false;
  invalidExtTwo:boolean=false;
  invalidNameFileOne:boolean=false;
  invalidNameFileTwo:boolean=false;
  dataIdentificacion = {
    cx_contenido_identificacion: '',
    cx_nombre_identificacion: '',
    cx_formato_identificacion: '',
    cx_contenido_rfc: '',
    cx_formato_rfc: '',
    cx_nombre_rfc: '',
    img_file_one: '',
    img_file_two: '',
    radio_identification: '000003',
    select_identification: '',
    number_files:'2',
    proof_address: '',
    cx_tipo_identificacion:'000003'
  };
  imgModal:any;
  showRadioFiles:boolean=false;
  url_img = URL_IMG;
  msgErrorFileOne:string='';
  msgErrorFileTwo:string='';

  constructor(private formBuilder:UntypedFormBuilder, 
              private spinner: NgxSpinnerService,
              private router: Router,
              private api: ApiService,
              private apiAnalytics :ApiAnalyticsService,
              private data: DataService,
              private modalService: NgbModal) 
  { 
    this.validateSession();
    this.getIdTypes();    
    this.subscribeFile();
    this.buildForm();
  }

  subscribeFile() {
    this.subsFileOne = this.data.fileIDFront.subscribe(file => this.dataIdentificacion.img_file_one = file);
    this.subsFileTwo = this.data.fileIDBack.subscribe(filewo => this.dataIdentificacion.img_file_two = filewo);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.data.setStep('opciones/autonomo-identificacion');
  }

  validateSession() {    
    if( sessionStorage.getItem('data_identification') ) { 
      this.dataIdentificacion = JSON.parse( sessionStorage.getItem('data_identification') );  
      if(this.dataIdentificacion.radio_identification == '0') {
        this.showRadioFiles=true;
      } else {
        this.showRadioFiles=false;
      }
      console.log(this.dataIdentificacion);
    } 
  }

  getIdTypes() {
    this.spinner.show();
    this.api.getIdTypes().subscribe((data: any[]) => {
      this.spinner.hide();
      if(data == undefined) {
        this.typeIDRadio.setValue('0');
        this.setValidationId();
      } else {
        if(data.length > 0) {
          this.idTypes = data;
          this.reOrderIdTypes();
        } else {
          this.typeIDRadio.setValue('0');
          this.setValidationId();
        }        
      }      
    }, error => {
      this.spinner.hide();
      this.typeIDRadio.setValue('0');
      this.setValidationId();
      console.log('Error: ', error);
    });
  }

  reOrderIdTypes() {
    let countRadio=0;
    let countSelect=0;
    Object.keys(this.idTypes).map((key) => {
      if(this.idTypes[key].type != undefined && this.idTypes[key].text != undefined) {
        switch(this.idTypes[key].type){
          case '000003':
            this.idTypesRadio[countSelect]=this.idTypes[key];
            countSelect++;
            break;
          default:
            this.idTypesSelect[countRadio]=this.idTypes[key];
            countRadio++;
          break;
        }
      }         
    }); 

    if(this.idTypesRadio.length == 0){
      this.typeIDRadio.setValue('0');
      this.setValidationId();
    }
  }

  private buildForm() {
    let validatorsOne;
    let validatorsTwo;
    if(this.dataIdentificacion.cx_contenido_identificacion =='') {
      validatorsOne = [Validators.required];
    } else {
      validatorsOne = [];
    }
    
    if(this.dataIdentificacion.number_files == '2' && this.dataIdentificacion.cx_contenido_rfc =='') {
      validatorsTwo = [Validators.required];
    } else if(this.dataIdentificacion.number_files == '2' && this.dataIdentificacion.cx_contenido_rfc !='') {
      validatorsTwo = [];
    } else if(this.dataIdentificacion.number_files == '1') {
      validatorsTwo = [];
    }

    this.form = this.formBuilder.group({
      radio_identification: [this.dataIdentificacion.radio_identification, [Validators.required] ],
      select_identification: [this.dataIdentificacion.select_identification],
      number_files:[this.dataIdentificacion.number_files, [Validators.required]],
      file_one: ['', validatorsOne ],
      file_two:['', validatorsTwo],
      proof_address:[this.dataIdentificacion.proof_address,[Validators.required]]
    })
  }

  get typeIDRadio() {
    return this.form.get('radio_identification');
  }

  get typeIDSelect() {
    return this.form.get('select_identification');
  }

  get numberFilesRadio() {
    return this.form.get('number_files');
  }

  get proofAddressInput() {
    return this.form.get('proof_address');
  }

  get inputFileOne() {
    return this.form.get('file_one');
  }

  get inputFileTwo() {
    return this.form.get('file_two');
  }

  previous(type) {
    console.log(`Autonomo | Paso1 | ${this.numberFilesRadio.value}archivos | ${type}Regresar`);
    this.apiAnalytics.gTag(`Autonomo | Paso1 | ${this.numberFilesRadio.value}archivos | ${type}Regresar`, 'Autonomo | Paso1', 'Tres Pasos Bursanet','1');
    this.router.navigate(['/registro'])
  }

  setValidationId() {    

    console.log('setValidationId: '+this.typeIDRadio.value);    

    if(this.typeIDRadio.value == '0') {
      this.form.get('select_identification').setValidators([Validators.required]);
      this.form.get('select_identification').updateValueAndValidity();      
      this.dataIdentificacion.cx_tipo_identificacion = '';   
      this.showRadioFiles=true;
      this.file_text='Selecciona archivo';
      this.form.get('file_two').clearValidators();
      this.form.get('file_two').updateValueAndValidity();
    } else {
      this.file_text='Selecciona frente';
      this.showRadioFiles=false;
      this.form.controls['select_identification'].setValue('');
      this.form.get('select_identification').clearValidators();
      this.form.get('select_identification').updateValueAndValidity();   
      this.form.get('file_two').setValidators([Validators.required]);
      this.form.get('file_two').updateValueAndValidity();
      this.numberFilesRadio.setValue('2');

      for (const item in this.idTypes) {
        if(this.idTypes[item].type == this.typeIDRadio.value) {
          this.dataIdentificacion.cx_tipo_identificacion = this.idTypes[item].type;
        }
      }
    }
    console.log(this.dataIdentificacion.cx_tipo_identificacion);
  }

  setTypeIDSelect() {
    console.log(this.typeIDSelect.value);    
    this.form.controls['radio_identification'].setValue('0');
    this.form.get('select_identification').setValidators([Validators.required]);
    this.form.get('select_identification').updateValueAndValidity();
    this.showRadioFiles=true;
    this.file_text='Selecciona archivo';
    if(this.typeIDSelect.value == '') {
      this.dataIdentificacion.cx_tipo_identificacion = '';
    } else {
      for (const item in this.idTypes) {
        if(this.idTypes[item].type == this.typeIDSelect.value) {
          this.dataIdentificacion.cx_tipo_identificacion = this.idTypes[item].type;
        }
      }
    }
    console.log(this.dataIdentificacion.cx_tipo_identificacion);
  }

  showIDImgFront():boolean {
    if(this.dataIdentificacion.img_file_one != '') {
      return false;
    } else {
      return true;
    }
  }

  showIDImgReverse():boolean {
    if(this.dataIdentificacion.img_file_two != '') {
      return false;
    } else {
      return true;
    }
  }

  showFileText(type):boolean {
    if(this.showRadioFiles) {
      return true;
    } else {
      let number_files = this.form.get('number_files').value;
      if(type == '1' && number_files == '1' ) {
        return false;
      } else if(type == '2' && number_files == '2' ) {
        return false;
      } else {
        return true;
      }
    }    
  }

  showInputsFiles(type) {
    let number_files = this.form.get('number_files').value;
    if(type  == '1' && this.dataIdentificacion.img_file_one == '') {
      return false;
    } else if(type  == '2' && number_files == '2' && this.dataIdentificacion.img_file_two == '') {
      if(this.typeIDRadio.value == '0') {
        return true;
      } else {
        return false;
      }
    }  else {
      return true;
    }
  }

  setValidationFile() {
    this.showFiles=true;
    let number_files = this.form.get('number_files').value;
    console.log(number_files);

    this.dataIdentificacion.cx_formato_rfc='';
    this.dataIdentificacion.cx_nombre_rfc='';
    this.dataIdentificacion.cx_contenido_rfc='';
    this.dataIdentificacion.cx_contenido_identificacion='';
    this.dataIdentificacion.cx_formato_identificacion='';
    this.dataIdentificacion.cx_nombre_identificacion='';
    this.dataIdentificacion.img_file_one='';
    this.dataIdentificacion.img_file_two='';
    this.form.controls['file_one'].setValue('');
    this.form.controls['file_two'].setValue('');

    if(number_files == '1') {      
      this.file_text='Seleccionar archivo';  
      this.form.get('file_one').setValidators([Validators.required]);
      this.form.get('file_one').updateValueAndValidity();    
      this.form.get('file_two').clearValidators();
      this.form.get('file_two').updateValueAndValidity();
      this.invalidSizetwo = false;
      this.invalidExtTwo = false;
      this.invalidNameFileTwo=false;
      this.showFileTwo=false;
    } else if(number_files == '2') {
      this.file_text='Seleccionar frente';      
      this.form.get('file_two').setValidators([Validators.required]);
      this.form.get('file_two').updateValueAndValidity();
      this.showFileTwo=true;
    }
  }

  uploadFileId(event, type) {
    
    const fileList: FileList = event.target.files;
    console.log('Tipo de Archivo: '+type);

    if (fileList.length > 0) {

      if(fileList[0].name.length <= 50) {
        if (!this.validateSizeFile(fileList[0].size, type)) {
          console.log('Arhivo Invalido Tamaño');
          this.clearInputFile(type);
          if(type == 1) {
            this.invalidExtOne = false;
            this.invalidNameFileOne=false;
            this.msgErrorFileOne='';
          } else if(type == 2) {
            this.invalidExtTwo = false;
            this.invalidNameFileTwo=false;
            this.msgErrorFileTwo='';
          }  
          return;
        }
  
        if (!this.validateExtFile(fileList[0].name, type)) {
          console.log('Arhivo Invalido Extension');
          this.clearInputFile(type);
          if(type == 1) {
            this.invalidSizeOne = false;
            this.invalidNameFileOne=false;
            this.msgErrorFileOne='';
          } else if(type == 2) {
            this.invalidSizetwo = false;
            this.invalidNameFileTwo=false;
            this.msgErrorFileTwo='';
          }  
          return;
        }
  
        this.spinner.show();
        const file: File = fileList[0];
        const formData: FormData = new FormData();
        formData.append('file-all', file, file.name);
        formData.append('currentFile-all', '0');
  
        this.api.actionUploadFile(formData).subscribe((data: any) => {

          this.spinner.hide();
          
          if(data == null || data == undefined) {
            this.clearInputFile(type);
            if(type == 1) {
              this.invalidSizeOne = false;
              this.invalidExtOne = false;
              this.invalidNameFileOne=false;
              this.msgErrorFileOne='Error al invocar el servicio';
            } else if(type == 2) {
              this.invalidSizetwo = false;
              this.invalidExtTwo = false;
              this.invalidNameFileTwo=false;
              this.msgErrorFileTwo='Error al invocar el servicio';
            }
          } else {

            switch(type) {
              case 1:
                this.invalidSizeOne = false;
                this.invalidExtOne = false;
                this.invalidNameFileOne=false;
                if(data.Status == "Error") {
                  this.clearInputFile(type);
                  this.msgErrorFileOne=data.Description;
                } else {
                  this.dataIdentificacion.cx_contenido_identificacion = data.Code;
                  this.dataIdentificacion.cx_nombre_identificacion = data.nombre;
                  this.dataIdentificacion.cx_formato_identificacion = data.formato;
                  this.dataIdentificacion.img_file_one= data.fullBase64;                  
                  this.msgErrorFileOne='';
                }                
                break;
              case 2:
                this.invalidSizetwo = false;
                this.invalidExtTwo = false;
                this.invalidNameFileTwo=false;
                if(data.Status == "Error") {
                  this.clearInputFile(type);
                  this.msgErrorFileTwo=data.Description;
                } else {
                  this.dataIdentificacion.cx_contenido_rfc = data.Code;
                  this.dataIdentificacion.cx_nombre_rfc = data.nombre;
                  this.dataIdentificacion.cx_formato_rfc = data.formato;
                  this.dataIdentificacion.img_file_two= data.fullBase64;                  
                  this.msgErrorFileTwo='';
                }                
                break;
              default:
                break;
            }            
          }         
        }, error => {
          this.spinner.hide();
          this.clearInputFile(type);
          console.log(error);
        });

      } else {
        this.clearInputFile(type);
        if(type == 1) {
          this.invalidSizeOne = false;
          this.invalidExtOne = false;
          this.invalidNameFileOne=true;
          this.msgErrorFileOne='';
        } else if(type == 2) {
          this.invalidSizetwo = false;
          this.invalidExtTwo = false;
          this.invalidNameFileTwo=true;
          this.msgErrorFileTwo='';
        } 
      }
      
    } else {
      this.clearInputFile(type);
    }
  }

  clearInputFile(type) {
    if(type == 1) {
      this.dataIdentificacion.cx_contenido_identificacion = '';
      this.dataIdentificacion.cx_nombre_identificacion = '';
      this.dataIdentificacion.cx_formato_identificacion = '';
      this.dataIdentificacion.img_file_one= '';
      this.inputFileOne.setValue('');
      this.inputFileOne.setValidators([Validators.required]);
      this.inputFileOne.updateValueAndValidity();
    } else if(type == 2) {
      this.dataIdentificacion.cx_contenido_rfc = '';
      this.dataIdentificacion.cx_nombre_rfc = '';
      this.dataIdentificacion.cx_formato_rfc = '';
      this.dataIdentificacion.img_file_two= '';
      this.inputFileTwo.setValue('');
      this.inputFileTwo.setValidators([Validators.required]);
      this.inputFileTwo.updateValueAndValidity();
    }
  }

  validateSizeFile (size, type):boolean {
    const mb = size / 1024;
    console.log(mb);
    if (mb >= 5000) {
      if(type == 1) {
        this.invalidSizeOne = true;
      } else if(type == 2) {
        this.invalidSizetwo = true;
      }      
      return false;
    } else {
      if(type == 1) {
        this.invalidSizeOne = false;
      } else if(type == 2) {
        this.invalidSizetwo = false;
      }      
      return true;
    }
  }

  validateExtFile(fileName, type): boolean {
    const extension =  ( fileName.split('.').pop() ).toLowerCase();
    console.log(extension);
    if (extension !== 'jpg' && extension !== 'png' && extension !== 'pdf' && extension !== 'jpeg') {
      if(type == 1) {
        this.invalidExtOne = true;
      } else if(type == 2) {
        this.invalidExtTwo = true;
      }      
      return false;
    } else {
      if(type == 1) {
        this.invalidExtOne = false;
      } else if(type == 2) {
        this.invalidExtTwo = false;
      }      
      return true;
    }
  }

  showImgPDF(format, file):boolean {
    let ext:string
    if(file == '1') {
      ext = this.dataIdentificacion.cx_formato_identificacion;
    } else {
      ext = this.dataIdentificacion.cx_formato_rfc;
    }    

    switch(ext) {
      case 'image/jpeg':
        if(format == 'img' && file == '1' ) {
          return false;
        } else if(format == 'img' && file == '2' ) {
          return false;
        } else {
          return true;
        }
        break;
      case 'image/png':
        if(format == 'img' && file == '1' ) {
          return false;
        } else if(format == 'img' && file == '2' ) {
          return false;
        } else {
          return true;
        }
        break;
      case 'application/pdf':
        if(format == 'pdf' && file == '1' ) {
          return false;
        } else if(format == 'pdf' && file == '2' ) {
          return false;
        } else {
          return true;
        }
        break;
      default:
        return true;
        break;      
    }
  }

  openModalFront(content) {
    this.imgModal = this.dataIdentificacion.img_file_one;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }
  
  openModalReverse(content) {
    this.imgModal = this.dataIdentificacion.img_file_two;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }

  saveStepOne(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();
    console.log(this.form.valid)
    if(this.form.valid) {

      console.log(this.dataIdentificacion)
      this.dataIdentificacion.radio_identification = this.typeIDRadio.value;
      this.dataIdentificacion.select_identification = this.typeIDSelect.value;
      this.dataIdentificacion.number_files = this.numberFilesRadio.value;
      this.dataIdentificacion.proof_address = this.proofAddressInput.value;
      this.data.updateFileIDFront(this.dataIdentificacion.img_file_one);
      this.data.updateFileIDBack(this.dataIdentificacion.img_file_two);
      delete this.dataIdentificacion.img_file_one;
      delete this.dataIdentificacion.img_file_two;

      if(this.dataIdentificacion.proof_address == '1') {
        sessionStorage.removeItem('data_proof_address');
      }

      sessionStorage.removeItem('data_identification');
      sessionStorage.setItem('data_identification', JSON.stringify(this.dataIdentificacion) );

      console.log(`Autonomo | Paso1 | ${this.numberFilesRadio.value}archivos | Continuar`);
      this.apiAnalytics.gTag(`Autonomo | Paso1 | ${this.numberFilesRadio.value}archivos | Continuar`, 'Autonomo | Paso1', 'Tres Pasos Bursanet','1');     

      if(this.dataIdentificacion.proof_address == '0') {
        this.router.navigate(['/opciones/autonomo-comprobante']);
      } else if(this.dataIdentificacion.proof_address == '1') {
        this.router.navigate(['/opciones/autonomo-completa-informacion']);
      }
      
    }
  }

}

